export default "/images/cat-logo-2.png?60d07a4d7919df3e0981ee499c8154b5";